import { useContext } from "react";
import PermissionContext from "../store/permission-context";

const usePermissions = () => {
    const permissionContext = useContext(PermissionContext);
    return new Set(permissionContext.permissions);
};

export default usePermissions;